export default ({ request }) => ({
  sysMerchantListApi(data = {}) {
    return request({
      url: '/sys/log/list',
      method: 'post',
      data,
    })
  },
  sysMerchantDetailApi(data = {}) {
    return request({
      url: '/sys/log/detail',
      method: 'post',
      data,
    })
  },
  sysMerchantSaveApi(data = {}) {
    return request({
      url: '/sys/log/save',
      method: 'post',
      data,
    })
  },
})
